const PSYCHIATRY = 'psychiatry'
const MATCH_PROFESSIONAL_SHOWCASE = 'MATCH_PROFESSIONAL_SHOWCASE'
const ALLOW_PROFESSIONAL_CANCELLATION = 'ALLOW_PROFESSIONAL_CANCELLATION'
const ENABLE_AUDIO_TRANSCRIPTION = 'ENABLE_AUDIO_TRANSCRIPTION'

export const featureName = {
  PSYCHIATRY,
  MATCH_PROFESSIONAL_SHOWCASE,
  ALLOW_PROFESSIONAL_CANCELLATION,
  ENABLE_AUDIO_TRANSCRIPTION,
}
